import { combineReducers } from 'redux';
// import { routerReducer } from 'react-router-redux';
export const reducer = combineReducers({});
//# sourceMappingURL=reducer.js.map


// WEBPACK FOOTER //
// ./src/reducer.js